var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 0H2.66667C1.19391 0 0 1.19391 0 2.66667V4.66667C0 6.13943 1.19391 7.33333 2.66667 7.33333H4.66667C6.13943 7.33333 7.33333 6.13943 7.33333 4.66667V2.66667C7.33333 1.19391 6.13943 0 4.66667 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 0H11.3333C9.86053 0 8.66663 1.19391 8.66663 2.66667V4.66667C8.66663 6.13943 9.86053 7.33333 11.3333 7.33333H13.3333C14.8061 7.33333 16 6.13943 16 4.66667V2.66667C16 1.19391 14.8061 0 13.3333 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 8.66669H2.66667C1.19391 8.66669 0 9.86059 0 11.3334V13.3334C0 14.8061 1.19391 16 2.66667 16H4.66667C6.13943 16 7.33333 14.8061 7.33333 13.3334V11.3334C7.33333 9.86059 6.13943 8.66669 4.66667 8.66669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.66669H11.3333C9.86053 8.66669 8.66663 9.86059 8.66663 11.3334V13.3334C8.66663 14.8061 9.86053 16 11.3333 16H13.3333C14.8061 16 16 14.8061 16 13.3334V11.3334C16 9.86059 14.8061 8.66669 13.3333 8.66669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.19ae98fcc03a868310cdf918f8fba491.svg";
export { ForwardRef as ReactComponent };